import React from 'react';

const Contact = () => (
  <section id="contact" style={{ padding: "40px 24px 80px" }}>
    <div style={{ maxWidth: "600px", margin: "0 auto", textAlign: "center" }}>
      <h2 className="text-4xl font-bold mb-6 text-pink-400">Let's Work Together</h2>
      <p style={{
        color: "#9ca3af",
        fontSize: "1rem",
        lineHeight: 1.8,
        marginBottom: "40px",
      }}>
        Open to new projects of all kinds. Whether it's a redesign, website updates and maintenance, or something in between, feel free to reach out.
      </p>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
        <a
          href="mailto:adamksmetana@gmail.com"
          className="cta-primary bg-gradient-to-r from-teal-500 to-teal-600 text-white font-semibold hover:from-teal-400 hover:to-teal-500 transition-all duration-300"
          style={{
            display: "inline-flex", alignItems: "center", gap: "8px",
            textDecoration: "none",
            padding: "14px 36px", borderRadius: "5px",
            fontSize: "0.95rem",
          }}
        >
          Send Me an Email
        </a>
        <a
          href="https://www.linkedin.com/in/adamsmetana"
          target="_blank"
          rel="noreferrer"
          style={{
            fontSize: "0.8rem",
            color: "#2dd4bf",
            textDecoration: "none",
            letterSpacing: "0.06em",
            borderBottom: "1px solid rgba(45,212,191,0.5)",
            paddingBottom: "2px",
            transition: "color 0.2s",
          }}
          onMouseEnter={e => e.currentTarget.style.color = "#fff"}
          onMouseLeave={e => e.currentTarget.style.color = "#2dd4bf"}
        >
          LinkedIn
        </a>
      </div>
    </div>
  </section>
);

export default Contact;
